<template>
  <div
    v-if="color"
    class="grid grid-cols-10 items-center gap-2 mb-10 select-none"
  >
    <div
      v-for="(item, index) in Object.values(generateShades(color)).reverse()"
      :key="index"
    >
      <p
        :class="['border w-fit h-fit p-5 xl:p-11']"
        :style="{ background: item }"
      ></p>
      <div class="text-center my-2">
        <p class="!font-bold">
          {{ Object.keys(generateShades(color)).reverse()[index] }}
        </p>
        <p class="text-[10px] xl:text-[12px]">{{ item }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { generateShades } from "@/store/theme";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "PreviewColors",
  props: {
    color: String as PropType<any>,
  },
  setup() {
    return { generateShades };
  },
});
</script>
